const pfx = process.env.NODE_ENV === 'production' ? '/xnyeyweb/' : '/xnyeyweb/'

export const environments = [
  {
    id: '',
    name: 'None',
    path: null,
  },
  {
    id: 'neutral', // THREE.RoomEnvironment
    name: 'Neutral',
    path: null,
  },
  {
    id: 'venice-sunset',
    name: 'Venice Sunset',
    path: pfx + 'hdr/venice_sunset_1k.hdr',
    format: '.hdr'
  },
  {
    id: 'classroom',
    name: 'classroom',
    path: pfx + 'hdr/Classroom1024.hdr',
    format: '.hdr'
  },
];
